<template>
  <div>
    <div>
      <el-button @click="apply">下发商品配置</el-button>
      <el-button type="primary" @click="show = true">添加商品</el-button>
      <div style="float: right">
        客户端类型：
        <el-select v-model="type">
          <el-option
            v-for="item of typeOptions"
            :key="item.label"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
      </div>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="list"
        :row-key="(row) => row.id + row.updatedTime"
        height="100%"
      >
        <el-table-column label="编号" align="center" type="index" />
        <el-table-column label="名称" align="center" prop="title" />
        <el-table-column label="icon" align="center" width="100">
          <template slot-scope="scope">
            <preview-picture :src="scope.row.icon | getImage" />
          </template>
        </el-table-column>
        <el-table-column label="价值金豆数量" width="120" align="center" prop="idouNum">
          <template slot-scope="scope">{{ scope.row.idouNum | numberChip }}</template>
        </el-table-column>
        <el-table-column label="价格" align="center" prop="price" />
        <el-table-column label="折扣" align="center" prop="discount" width="80" />
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="scope">{{ scope.row.status | statusName }}</template>
        </el-table-column>
        <el-table-column label="最后更新时间" align="center" prop="updatedTime" width="180" />
        <el-table-column label="属性" min-width="150" align="center" prop="clientTypes">
          <template slot-scope="scope">{{ scope.row.clientTypes | clientTypeName }}</template>
        </el-table-column>
        <el-table-column label="备注" min-width="150" align="center" prop="remark" />
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editFunc(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="removeItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>商品编辑</h3>
        <el-form :model="form">
          <table class="common-popup-table" style="width: 700px">
            <tr>
              <td class="required">属性：</td>
              <td colspan="5">
                <el-checkbox-group style="display: inline-block" v-model="form.clientTypes">
                  <el-checkbox label="1">android</el-checkbox>
                  <el-checkbox label="2">ios</el-checkbox>
                  <el-checkbox label="3">web</el-checkbox>
                  <el-checkbox label="4">wap</el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td class="required">名称：</td>
              <td colspan="3">
                <el-input placeholder="请输入" v-model="form.title" size="medium" />
              </td>
              <td class="required">状态：</td>
              <td>
                <el-select v-model="form.status" size="medium">
                  <el-option
                    v-for="item of statusOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="required">价格：</td>
              <td>
                <el-input placeholder="请输入" type="number" v-model="form.price" size="medium" />
              </td>
              <td>折扣：</td>
              <td>
                <el-input
                  type="number"
                  v-model="form.discount"
                  size="medium"
                  placeholder="范围0~1"
                />
              </td>
              <td class="required">金豆数：</td>
              <td>
                <el-input placeholder="请输入" type="number" v-model="form.idouNum" size="medium" />
              </td>
            </tr>
            <tr>
              <td class="required">code：</td>
              <td>
                <el-input placeholder="请输入" v-model="form.code" size="medium" />
              </td>
              <td class="required">icon：</td>
              <td rowspan="2">
                <div class="common-uploadImg">
                  <input @change="fileChange" type="file" accept="image/*" />
                  <img v-if="form.icon" :src="form.icon | getImage" class="avatar" />
                  <i v-else class="el-icon-plus"></i>
                </div>
              </td>
            </tr>
            <tr>
              <td>权重：</td>
              <td>
                <el-input type="number" v-model="form.sortNo" size="medium" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td colspan="5">
                <el-input v-model="form.remark" type="textarea" resize="none" />
              </td>
            </tr>
          </table>
        </el-form>
        <footer>
          <el-button size="small" @click="close">取消</el-button>
          <el-button size="small" @click="submit" type="primary">确定</el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import previewPicture from 'components/previewPicture';

export default {
  components: {
    previewPicture,
  },
  data() {
    return {
      loading: false,
      show: false,
      currentPage: 1,
      type: '',
      typeOptions: [
        // 客户端类型
        {
          label: '全部',
          value: '',
        },
        {
          label: 'android',
          value: '1',
        },
        {
          label: 'ios',
          value: '2',
        },
        {
          label: 'web',
          value: '3',
        },
        {
          label: 'wap',
          value: '4',
        },
      ],
      statusOptions: [
        // 状态类型
        {
          label: '下架',
          value: 0,
        },
        {
          label: '上架',
          value: 1,
        },
      ],
      form: {
        id: null,
        title: null, // 商品名称
        channelId: 3, // 使用渠道
        clientTypes: [], // 使用客户端类型
        isIospay: false, // 是否内购
        price: null, // 价格
        discount: null, // 折扣
        idouNum: null, // 价值金豆数
        status: null, // 状态
        code: null, // 商品编码
        icon: null, // 图标URL
        sortNo: null, // 排序号
        remark: '', // 备注
      },
      imgFile: null, // 选择上传的图片
    };
  },
  computed: {
    ...mapState('product', ['productList']),
    list() {
      // 客户端类型筛选
      if (this.type) {
        return this.productList.filter((item) => {
          if (item.clientTypes.indexOf(this.type) > -1) {
            return item;
          }
        });
      }
      return this.productList;
    },
  },
  created() {
    this.getList(this.form.channelId);
  },
  filters: {
    statusName(status) {
      switch (status) {
        case 0:
          status = '下架';
          break;
        case 1:
          status = '上架';
          break;
        default:
          break;
      }
      return status;
    },
    clientTypeName(types) {
      // 使用客户端类型
      let arr = types.split(',');
      return arr
        .map((type) => {
          switch (type) {
            case '1':
              type = 'android';
              break;
            case '2':
              type = 'ios';
              break;
            case '3':
              type = 'web';
              break;
            case '4':
              type = 'wap';
              break;
            default:
              break;
          }
          return type;
        })
        .join(',');
    },
  },
  methods: {
    ...mapActions('other', ['uploadImg']),
    ...mapActions('product', ['getProductList', 'updateProduct', 'deleteProduct', 'applyProduct']),
    getList(channelId) {
      this.loading = true;
      this.getProductList(channelId).then(() => {
        this.loading = false;
      });
    },
    removeItem(id) {
      this.loading = true;
      this.deleteProduct(id).then(() => {
        this.$message.success('删除成功');
        this.getList(this.form.channelId);
      });
    },
    editFunc(info) {
      this.show = true;
      info.idouNum = info.idouNum / 100;
      for (let key in this.form) {
        if (key === 'clientTypes') {
          this.form[key] = info[key].split(',');
        } else {
          this.form[key] = info[key];
        }
      }
    },
    close() {
      this.show = false;
      Object.assign(this.form, {
        id: null,
        title: null, // 商品名称
        clientTypes: [], // 使用客户端类型
        isIospay: false, // 是否内购
        price: null, // 价格
        discount: null, // 折扣
        idouNum: null, // 价值金豆数
        status: null, // 状态
        code: null, // 商品编码
        icon: null, // 图标URL
        sortNo: null, // 排序号
        remark: '', // 备注
      });
    },
    async submit() {
      if (this.form.title === null) {
        this.$message.error('请输入名称');
        return;
      } else if (!this.form.clientTypes.length) {
        this.$message.error('请选择属性');
        return;
      } else if (this.form.price === null) {
        this.$message.error('请输入价格');
        return;
      } else if (
        this.form.discount !== null &&
        (this.form.discount > 1 || this.form.discount < 0)
      ) {
        this.$message.error('折扣范围0~1');
        return;
      } else if (this.form.idouNum === null) {
        this.$message.error('请输入金豆数');
        return;
      } else if (this.form.status === null) {
        this.$message.error('请选择状态');
        return;
      } else if (this.form.code === null) {
        this.$message.error('请输入code');
        return;
      } else if (this.form.icon === null) {
        this.$message.error('请选择icon');
        return;
      }

      if (this.imgFile) {
        let params = new FormData();
        params.append('file', this.imgFile);
        this.form.icon = await this.uploadImg(params).then((res) => {
          return `${res.data.imageUrl}`; //http://${res.data.file_ip}:${res.data.file_port}
        });
        this.imgFile = null;
      }
      let params = Object.assign({}, this.form, {
        clientTypes: this.form.clientTypes.join(','),
      });
      params.idouNum = params.idouNum * 100;
      this.updateProduct(params).then(() => {
        this.$message.success('操作成功');
        this.close();
        this.getList(this.form.channelId);
      });
    },
    fileChange(e) {
      if (e.target.files.length) {
        this.imgFile = e.target.files[0];
        let f = new Blob([this.imgFile]);
        this.form.icon = URL.createObjectURL(f);
      }
    },
    // 下发商品配置
    apply() {
      this.applyProduct(this.form.channelId).then(() => {
        this.$message.success('下发商品配置成功');
      });
    },
  },
};
</script>
